import React from 'react'
import cx from 'classnames'
import IconSVG from 'svg-inline-react'

import UISelect from 'components/shared/UISelect'
import { KeywordType } from 'app/modules/playbook/constants'

import xIconSrc from '!svg-inline!images/navigation/close.svg'

import './style.styl'

const KEYWORD_OPTIONS = [
  {
    value: KeywordType.FUZZY,
    label: 'Similar to',
  },
  {
    value: KeywordType.CONTAINS,
    label: 'Contains',
  },
  {
    value: KeywordType.EQUALS,
    label: 'Equals',
  },
]

const Keyword = ({
  onDeleteClick,
  onTextChange,
  keyword: {
    special,
    text,
    type,
  },
  onTypeChange
}) => (
  <div className={cx('playbook-keyword', 'flex', 'drift-form')}>
    <UISelect
      disabled={special}
      value={KEYWORD_OPTIONS.find(({ value }) => value === type)}
      options={KEYWORD_OPTIONS}
      onChange={onTypeChange}
    />
    <input
      type="text"
      className="flex-1"
      onChange={onTextChange}
      disabled={special}
      required
      value={text}
    />
    <IconSVG
      className="playbook-keyword-delete-icon"
      src={xIconSrc}
      onClick={onDeleteClick}
    />
  </div>
)

export default Keyword



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Keyword/component.js